import React, { useRef, useState } from "react";
import onboarding1 from "../../images/Onboarding-1.jpg";
import onboarding2 from "../../images/onboarding-2.jpg";
import onboarding3 from "../../images/onboarding-3.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useHistory } from "react-router";

const SampleNext = (props) => {
  const { className, slider, counter, title, addSlideCounter } = props;

  const history = useHistory();

  const handleClick = () => {
    if (counter <= 2) {
      addSlideCounter(counter + 1);
      slider.current.slickNext();
    } else {
      history.push("/signup");
    }
  };

  return (
    <button className={className} onClick={handleClick}>
      {title}
    </button>
  );
};

const OnBoarding = () => {
  const slider = useRef(null);
  const history = useHistory();
  const [counter, addSlideCounter] = useState(1);

  var welcomeslider = {
    dots: true,
    nav: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    nextArrow: (
      <SampleNext
        slider={slider}
        counter={counter}
        addSlideCounter={addSlideCounter}
      />
    ),
    responsive: [
      {
        breakpoint: 9999,
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="onboarding">
      <div className="loginsidebar-inner">
        <Slider className="welcome-block" {...welcomeslider} ref={slider}>
          <div className="item">
            <div className="login-img">
              <img src={onboarding1} alt="welcome" />
            </div>
            <div className="item-content">
              <div className="skip-btn">
                <button
                  onClick={() => {
                    history.push("/signup");
                  }}
                >
                  Skip for now{" "}
                </button>
              </div>
              <h2>Show Case Your Council</h2>
              <p>
                {" "}
                Communicate with Local Residents and Visitors to the Region.{" "}
              </p>
              {/* <div className="slider-next">
                                <SampleNext title="Next" slider={slider} counter={counter} addSlideCounter={addSlideCounter} className="slick-next" />
                            </div> */}

              <div className="next-btn">
                <SampleNext
                  title="Next"
                  slider={slider}
                  counter={counter}
                  addSlideCounter={addSlideCounter}
                  className="slick-next"
                />
              </div>
            </div>
          </div>
          <div className="item">
            <div className="login-img">
              <img src={onboarding2} alt="welcome" />
            </div>
            <div className="item-content">
              <div className="skip-btn">
                <button
                  onClick={() => {
                    history.push("/signup");
                  }}
                >
                  Skip for now{" "}
                </button>
              </div>
              <h2>Keep The Community Updated On Local Events</h2>
              <p>
                Promote Local Events including WhatzOn in your area to both
                residents and visitors to the Region.{" "}
              </p>
              <div className="next-btn">
                <SampleNext
                  title="Next"
                  slider={slider}
                  counter={counter}
                  addSlideCounter={addSlideCounter}
                  className="slick-next"
                />
              </div>
              {/* <div className="slider-next">
                                <SampleNext title="Next" slider={slider} counter={counter} addSlideCounter={addSlideCounter} className="slick-next" />
                            </div> */}
            </div>
          </div>
          <div className="item">
            <div className="login-img">
              <img src={onboarding3} alt="welcome" />
            </div>
            <div className="item-content">
              <div className="skip-btn">
                <button
                  onClick={() => {
                    history.push("/signup");
                  }}
                >
                  Skip for now{" "}
                </button>
              </div>
              <h2>Keep The Community Updated About Local Attractions</h2>
              <p>
                Promote Local Attractions, sell tickets and a whole lot more.
                Whatzon is simple to use and is completely Free to Councils
                Australia wide.{" "}
              </p>
              <div className="next-btn">
                <SampleNext
                  title="Get Started"
                  slider={slider}
                  counter={counter}
                  addSlideCounter={addSlideCounter}
                  className="slick-next"
                />
              </div>
              {/* <div className="slider-next">
                                <SampleNext title="Get Started" slider={slider} counter={counter} addSlideCounter={addSlideCounter} className="slick-next" />
                            </div> */}
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default OnBoarding;
